import { render, staticRenderFns } from "./CollegeCoursesDetail.vue?vue&type=template&id=476f7c1e&scoped=true&"
import script from "./CollegeCoursesDetail.vue?vue&type=script&lang=js&"
export * from "./CollegeCoursesDetail.vue?vue&type=script&lang=js&"
import style0 from "./CollegeCoursesDetail.vue?vue&type=style&index=0&id=476f7c1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476f7c1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VIcon,VProgressLinear,VRow})
